<app-layout>
  <div class="report-detail-page">
    <mat-toolbar class="page-header" role="heading">
      <div class="page-header-title">
        <div class="page-header-copy">
          <span class="eyebrow" appLocalizationPopupDirective localizationCode="Reports">
            {{ 'Reports' | translate: {Default: 'Reports'} }}
          </span>
          <h1>
            {{ reportName }}
          </h1>
        </div>
      </div>

      <div class="page-header-actions">
        <button
          class="back-button"
          mat-stroked-button
          appPreventDoubleClick
          (throttledClick)="backToReportGroups()"
          matTooltip="{{ 'BackToReports' | translate: {Default: 'Back to Reports'} }}"
          appLocalizationPopupDirective
          localizationCode="BackToReports"
        >
          <mat-icon aria-hidden="false" class="material-icons-outlined">arrow_back</mat-icon>
          {{ 'BackToReports' | translate: {Default: 'Back to reports'} }}
        </button>

        <button
          mat-flat-button
          setColor="primaryColour"
          color="primary"
          appPreventDoubleClick
          (throttledClick)="runReport()"
          [disabled]="isRunningReport"
          appLocalizationPopupDirective
          localizationCode="RunReport"
        >
          <mat-icon aria-hidden="false" class="material-icons-outlined" aria-label="run icon">play_arrow</mat-icon>
          {{ 'RunReport' | translate: {Default: 'Run report'} }}
        </button>
      </div>
    </mat-toolbar>

    <mat-card class="description-card">
      <mat-card-content>
        <ng-container *ngIf="!isLoadingReport; else descriptionLoading">
          <p *ngIf="report?.description; else noDescription">{{ report.description }}</p>
          <ng-template #noDescription>
            <p class="empty-description">{{ 'NoDescriptionProvided' | translate: {Default: 'No description provided.'} }}</p>
          </ng-template>
        </ng-container>
        <ng-template #descriptionLoading>
          <p class="empty-description">{{ 'Loading' | translate: {Default: 'Loading…'} }}</p>
        </ng-template>
      </mat-card-content>
    </mat-card>

    <div class="grid-shell">
      <app-data-grid-comp
          [columns]="runsColumns"
          [gridDataResult]="runsGridDataResult"
          [isLoading]="isLoadingRuns"
          [pageSize]="runsPageSize"
          [skip]="runsSkip"
          [sort]="runsSort"
          [sortableColumns]="runsSortableColumns"
          [sortable]="{ mode: 'single' }"
          [filterCategories]="runsFilterCategories"
          [rowActionButtons]="runsRowActionButtons"
          showRefreshButton="true"
          hideActionButtons="true"
          clickableRows="true"
          category="ReportRuns"
          (emitPageChangeEvent)="runsPageChange($event)"
          (emitSortEvent)="runsSortChange($event)"
          (emitFilterEvent)="runsFilterCallback($event)"
          (emitRefreshEvent)="loadReportRuns()"
          (rowActionEvent)="runsRowAction($event)"
          (emitOpenDialogEvent)="onRunRowClick($event)"
      ></app-data-grid-comp>
    </div>
  </div>
</app-layout>
